import React from 'react';

import StateSelect from './StateSelect';
import { WrapContent } from './styles';

export const usersColumnsData = ({ EntityNotificationSelect, RoleSelect, updateMember }) => [
  {
    key: 'name',
    title: 'Name',
    component: row => (
      <WrapContent>
        <b>{row.name}</b>
      </WrapContent>
    ),
    isSort: false
  },
  {
    key: 'email',
    title: 'Email',
    component: row => <WrapContent lowercase>{row.email}</WrapContent>,
    isSort: false
  },
  {
    key: 'state',
    title: 'State',
    component: row => <StateSelect row={row} action={updateMember} />,
    isSort: false
  },
  {
    key: 'entity_notification',
    title: 'Notification',
    component: row => <EntityNotificationSelect row={row} action={updateMember} />,
    filterType: 'radio',
    isSort: false
  },
  {
    key: 'role',
    title: 'Role',
    component: row => <RoleSelect row={row} action={updateMember} />,
    filterType: 'radio',
    isSort: false
  }
];
